//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgPlusCircleThick } from '../icons/PlusCircleThick';

export function PlusCircleThickIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgPlusCircleThick} data-qa="PlusCircleThickIcon">
      <svg />
    </SvgIcon>
  );
}
